import { render, staticRenderFns } from "./form-upload.vue?vue&type=template&id=740c28d4"
import script from "./form-upload.vue?vue&type=script&lang=js"
export * from "./form-upload.vue?vue&type=script&lang=js"
import style0 from "./form-upload.vue?vue&type=style&index=0&id=740c28d4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports